export type TQueueItem<T = any> = () => Promise<T>;
export type TQueueOptions = { max: number };

/**
 * Uage
 *
 * Create a single instance of queue for group of proceses you want to limit
 *
 * const queue = new Queue({ max: 5 });
 *
 * Then process your tasks using queu
 *
 * const result = await queue.add(async () => ... do your logic ... );
 */
export class Queue {
    private items: TQueueItem[] = [];
    private processingRequests = 0;
    private options: TQueueOptions;

    constructor(options: Partial<TQueueOptions>) {
        this.options = { max: 10, ...options };
    }

    add<T>(cb: TQueueItem<T>): Promise<T> {
        const promise = new Promise<T>((resolve, reject) => {
            this.items.push(async () => {
                try {
                    resolve(await cb());
                } catch (error) {
                    reject(error);
                }
            });
        });
        this.onQueueChange();
        return promise;
    }

    private onQueueChange() {
        setTimeout(async () => {
            if (this.processingRequests < this.options.max) {
                const cb = this.items.shift();
                if (!cb) {
                    return;
                }
                this.processingRequests++;
                try {
                    return await cb();
                } finally {
                    this.processingRequests--;
                    setTimeout(() => this.onQueueChange());
                }
            }
        });
    }
}
